import React, { useEffect, useState } from "react";
import "./TrialBalance.css";
import { FileSpreadsheet } from "lucide-react";
import { toast } from "react-toastify";
import axios from "axios";

const TrialBalance = () => {
  const [trialBalance, setTrialBalance] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalDebit, setTotalDebit] = useState(0);
  const [totalCredit, setTotalCredit] = useState(0);

  useEffect(() => {
    const fetchTrialBalance = async () => {
      const superAdminId = localStorage.getItem("adminuserId");

      try {
        setLoading(true);

        const res = await axios.get(
          "https://payyug.in/api/report/trial-balance",
          { params: { superAdminId } }
        );

        setTrialBalance(res.data?.data || []);
        setTotalDebit(res.data?.totalDebit || 0);
        setTotalCredit(res.data?.totalCredit || 0);
      } catch (err) {
        toast.error(
          err.response?.data?.message || "Failed to fetch trial balance"
        );
      } finally {
        setLoading(false);
      }
    };

    fetchTrialBalance();
  }, []);

  return (
    <div className="trialbalance-container">
      <h1 className="trialbalance-title">Trial Balance</h1>

      <div className="trialbalance-report-section">
        <div className="trialbalance-report-top">
          <button className="trialbalance-export-btn">
            <FileSpreadsheet size={15} /> Export
          </button>
        </div>

        <div className="trialbalance-report-table">
          <table>
            <thead>
              <tr>
                <th>Ledger ID</th>
                <th>Ledger Name</th>
                <th>Total Debit</th>
                <th>Total Credit</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="4" align="center">
                    Loading...
                  </td>
                </tr>
              ) : trialBalance.length > 0 ? (
                trialBalance.map((item) => (
                  <tr key={item.ledgerId}>
                    <td>{item.ledgerId}</td>
                    <td>{item.ledger?.name || "-"}</td>
                    <td className="trialbalance-debit-text">
                      ₹{item.totalDebit || 0}
                    </td>
                    <td className="trialbalance-credit-text">
                      ₹{item.totalCredit || 0}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" align="center">
                    No Records Found
                  </td>
                </tr>
              )}

              {!loading && trialBalance.length > 0 && (
                <tr className="trialbalance-totalRow">
                  <td colSpan="2"><strong>Total</strong></td>
                  <td className="trialbalance-debit-text">
                    <strong>₹{totalDebit}</strong>
                  </td>
                  <td className="trialbalance-credit-text">
                    <strong>₹{totalCredit}</strong>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default TrialBalance;
